<template>
  <Report :product="product" isDetailsVisible>
    <template v-slot:callToAction>
      <SideBarOnCompanies :product="product" />
    </template>

    <template v-slot:default>
      <div class="structured-content-cluster positive">
        <span class="lead" v-html="product.description" />
      </div>

      <div
        class="structured-content-cluster"
        :class="index % 2 ? 'positive' : 'negative'"
        v-for="(item, index) in product.services"
        :key="item.code"
        @click.prevent
      >

        <h2 class="d-inline-block" v-html="product.serviceDetails[item.code].title" />
        <span class="price">{{ $price(item.price) }}</span>
        <span class="lead" v-html="product.serviceDetails[item.code].shortDescription" />

        <div class="content-accordion" role="tablist">
          <div class="card">
            <div class="card-header" role="tab">
              <a class="accordion-title collapsed" href="#" v-b-toggle="item.code">
                <span class="icon-arrow-down32" />
                <span class="icon-arrow-up32" />
                {{ $t('report.whatsInside') }}
              </a>
            </div>

            <BCollapse :id="item.code" class="fade">
              <div class="card-body with-content primary" v-html="product.serviceDetails[item.code].description" />
            </BCollapse>
          </div>
        </div>
      </div>
    </template>
  </Report>
</template>

<script>
import Report from './Report';
import SideBarOnCompanies from './SideBarOnCompanies';
import { BCollapse } from 'bootstrap-vue-next';

export default {
  props: ['product'],
  components: {
    BCollapse,
    Report,
    SideBarOnCompanies,
  },
};
</script>
